<template>
  <div class="product-info" id="product-info">

    <div class="product-image">
      <!-- 检测报告图片，点击可切换 -->
      <div class="image-container" @click="switchImage">
        <img 
          src="https://suyuan.yueshan2026.cn//profile/upload/2026/01/20/20260120174234A016.png" 
          class="d_img" 
          alt="产品图片" 
        />
        <!-- 图片指示器 -->
        <!-- <div class="image-indicator" v-if="inspectionImages.length > 1">
          <span>{{ currentImageIndex + 1 }}/{{ inspectionImages.length }}</span>
        </div> -->
      </div>
       <div class="product-tags">
        <div class="tag">
          <img class="tag-icon" src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115155657A005.png" alt="">
          <span>{{ tag1 }}</span>
        </div>
        <div class="tag">
          <img class="tag-icon" src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115155657A005.png" alt="">
          <span>{{ tag2 }}</span>
        </div>
      </div>
    </div>
    <div class="bottom_content">
     
    <div class="product-details">
      <div class="detail-item">
        <img class="detail-icon" src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115160624A006.png" alt="">
        <span class="detail-label">产品名称：</span>
        <span class="detail-value">{{ product.name }}</span>
      </div>
      <div class="detail-item">
        <img class="detail-icon" src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115160733A007.png" alt="">
        <span class="detail-label">规格：</span>
        <span class="detail-value">{{ product.spec }}</span>
      </div>
      <div class="detail-item">
        <img class="detail-icon" src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115160744A008.png" alt="">
        <span class="detail-label">馅料：</span>
        <span class="detail-value">{{ product.fillings }}</span>
      </div>
      <div class="detail-item">
        <img class="detail-icon" src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115160756A009.png" alt="">
        <span class="detail-label">生产批次：</span>
        <span class="detail-value">{{ product.batch }}</span>
      </div>
      <div class="detail-item">
        <img class="detail-icon" src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115160805A010.png" alt="">
        <span class="detail-label">生产日期：</span>
        <span class="detail-value">{{ product.productionDate }}</span>
      </div>
      <div class="detail-item">
        <img class="detail-icon" src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115160816A011.png" alt="">
        <span class="detail-label">保质期：</span>
        <span class="detail-value">{{ product.shelfLife }}</span>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import productApi from '@/api/modules/product'

export default {
  name: 'ProductInfo',
  props: {
    batch: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tag1: '清香萦绕 软糯于心',
      tag2: '家的味道',
      product: {
        name: '',
        spec: '',
        fillings: '',
        batch: '',
        productionDate: '',
        shelfLife: ''
      },
      // 图片相关数据
      inspectionImages: [], // 检测报告图片列表
      currentImageIndex: 0 // 当前显示的图片索引
    }
  },
  mounted() {
    this.getProductData()
  },
  methods: {
    async getProductData() {
      try {
        const response = await productApi.getProductList({
          pageNum: 1,
          pageSize: 1,
          batch: this.batch
        })
        
        if (response.success && response.data && response.data.records && response.data.records.length > 0) {
          const productData = response.data.records[0]
          // 映射接口字段到组件字段
          this.product = {
            ...this.product,
            name: productData.name,
            spec: productData.specification,
            fillings: productData.filling,
            batch: productData.batch,
            productionDate: productData.productionDate,
            shelfLife: productData.shelfLife
          }
          
          // 处理检测报告图片
          this.processInspectionImages(productData.inspectionReport)
          
          // 调用溯源码列表接口获取生产批次和生产日期
          await this.getCodeData(productData.batch)
        }
      } catch (error) {
        console.error('获取产品数据失败:', error)
      }
    },
    
    // 获取溯源码列表数据
    async getCodeData(batch) {
      try {
        const response = await productApi.getCodeList({
          pageNum: 1,
          pageSize: 1,
          batch: batch || this.batch
        })
        
        if (response.success && response.data && response.data.records && response.data.records.length > 0) {
          const codeData = response.data.records[0]
          // 更新生产批次和生产日期
          this.product.batch = codeData.batch || this.product.batch
          this.product.productionDate = codeData.productionDate || this.product.productionDate
          console.log('获取溯源码数据成功:', codeData)
        }
      } catch (error) {
        console.error('获取溯源码数据失败:', error)
      }
    },
    processInspectionImages(inspectionReport) {
      // 重置图片数据
      this.inspectionImages = []
      this.currentImageIndex = 0
      
      if (!inspectionReport) return
      
      try {
        // 尝试解析为JSON数组
        const images = JSON.parse(inspectionReport)
        if (Array.isArray(images)) {
          this.inspectionImages = images
        } else {
          // 如果不是数组，作为单个图片处理
          this.inspectionImages = [inspectionReport]
        }
      } catch (e) {
        // 如果解析失败，检查是否为逗号分隔的字符串
        if (typeof inspectionReport === 'string' && inspectionReport.includes(',')) {
          this.inspectionImages = inspectionReport.split(',').map(img => img.trim())
        } else {
          // 否则作为单个图片处理
          this.inspectionImages = [inspectionReport]
        }
      }
    },
    switchImage() {
      // 切换到下一张图片
      if (this.inspectionImages.length > 1) {
        this.currentImageIndex = (this.currentImageIndex + 1) % this.inspectionImages.length
      }
    }
  }
}
</script>

<style scoped>
.product-info {
  padding: 0;
  /* background:transparent; */
  /* background-color: #fff; */
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 15px;
  background-color: #4caf50;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}

.header-icon {
  font-size: 18px;
}

.product-image {
  width: 100%;
  margin-bottom: 16px;
  background:#fff;
  border-radius: 8px;
  padding:12px;
  box-sizing: border-box;
}

.image-container {
  position: relative;
  cursor: pointer;
  width: 100%;
  padding-bottom: 50%; /* 宽高比2:1 */
  height: 0;
  margin-bottom:6px;
    border-radius: 8px;
  overflow: hidden;
}

.d_img{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  /* height: 100%; */

  object-fit: contain;
  display:block;
}

.image-indicator {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 10;
}


.bottom_content{
  background:#fff;
   border-radius: 8px;
  /* padding-top:20px; */
}

.product-tags {
  display: flex;
  align-items: center;

  /* padding: 0 15px 10px; */
  margin-bottom: 0;
  flex-wrap: wrap;
}

.tag {
  /* background-color: #4caf50; */
  color: #333;
  /* padding: 5px 12px; */
  border-radius: 4px;
  
  display: flex;
  align-items: center;
  margin-right:12px;

}
.tag span{
  display: inline-block;
  font-size: 14px;

  padding-bottom:1px;

}

.tag-icon {
  margin-right:4px;
  width:20px;
  height:20px;
}

.product-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding:  20px 16px;
}

.detail-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.detail-icon {
  margin-right: 8px;
  color: #4caf50;
  font-size: 14px;
}

.detail-label {
 color: #999999;

  margin-right: 5px;
}

.detail-value {
  color: #333;
  font-weight: normal;
}

</style>